import * as yup from 'yup';
import i18next from 'i18next';

export const restaurantUserValidationSchema = yup.object({
  firstName: yup
    .string()
    .required(() =>
      i18next.t('validation.restaurant-user.first-name.required')
    ),
  lastName: yup
    .string()
    .required(() => i18next.t('validation.restaurant-user.last-name.required')),
  email: yup
    .string()
    .email(() => i18next.t('validation.restaurant-user.email.invalid'))
    .required(() => i18next.t('validation.restaurant-user.email.required')),
  role: yup
    .string()
    .required(() => i18next.t('validation.restaurant-user.role.required')),
});
